export var E_HEADER_TYPE;
(function (E_HEADER_TYPE) {
    E_HEADER_TYPE["MAIN_VIEW"] = "mainView";
    E_HEADER_TYPE["SUB_VIEW"] = "subView";
    E_HEADER_TYPE["SETTING_VIEW"] = "settingView";
    E_HEADER_TYPE["DETAIL_VIEW"] = "detailView";
    E_HEADER_TYPE["FREE_DETAIL_VIEW"] = "freeDetailView";
})(E_HEADER_TYPE || (E_HEADER_TYPE = {}));
